// extracted by mini-css-extract-plugin
module.exports = {"item_title":"detail-data-proa-locations_item_title__3rhOl"};